import { DollarSign, Euro, BadgeDollarSign, LucideIcon } from "lucide-react";

export const getCurrencySymbol = (currency: string = "ZAR"): string => {
  const symbols: Record<string, string> = {
    USD: "$",
    EUR: "€",
    ZAR: "R",
  };
  return symbols[currency.toUpperCase()] || "R";
};

export const getCurrencyIcon = (currency: string = "ZAR"): LucideIcon => {
  const icons: Record<string, LucideIcon> = {
    USD: DollarSign,
    EUR: Euro,
    ZAR: BadgeDollarSign,
  };
  return icons[currency.toUpperCase()] || BadgeDollarSign;
};

export const formatCurrency = (amount: number, currency: string = "ZAR"): string => {
  const symbol = getCurrencySymbol(currency);
  return `${symbol}${amount.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};
